import { UserAvatar } from '@/shared/components/custom/avatars';
import { getUserColor } from '@/core/lib/colors';
import { PerformanceCellBadge } from './PerformanceCellBadge';
import type { MemberTimelineEntry, DayColumn } from '../types';

interface PerformanceTimelineRowProps {
  entry: MemberTimelineEntry;
  days: DayColumn[];
}

export function PerformanceTimelineRow({ entry, days }: PerformanceTimelineRowProps) {
  const dailyMap = new Map(entry.dailyData.map((d) => [d.date, d]));
  const meta = [entry.schedule, entry.hourlyRate != null ? `$${entry.hourlyRate}/h` : null]
    .filter(Boolean)
    .join(' • ');

  return (
    <div
      data-testid={`labor-performance-timeline-row-${entry.memberId}`}
      className="flex items-center border-b last:border-b-0"
    >
      <div className="flex w-48 flex-shrink-0 flex-col justify-center gap-0.5 py-3 pl-4 pr-2 md:w-56">
        <div className="flex items-center gap-2">
          <UserAvatar
            name={entry.memberName}
            color={getUserColor(entry.memberId)}
            src={entry.memberAvatarUrl ?? undefined}
            size="sm"
          />
          <span className="truncate text-sm font-medium leading-tight">{entry.memberName}</span>
        </div>
        {meta && (
          <span className="pl-8 text-[10px] leading-tight text-muted-foreground truncate">
            {meta}
          </span>
        )}
      </div>

      <div className="flex flex-1 self-stretch">
        {days.map((day) => {
          const data = dailyMap.get(day.date);
          return (
            <div
              key={day.date}
              data-testid={`labor-performance-cell-${day.date}-${entry.memberId}`}
              className="flex flex-1 items-center justify-center border-l px-1 py-3"
            >
              <PerformanceCellBadge
                efficiency={data?.efficiency ?? null}
                taskCount={data?.taskCount ?? 0}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
